"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.getFormattedTransactions = getFormattedTransactions;
exports.walletHistoryFactory = walletHistoryFactory;
var _find2 = _interopRequireDefault(require("lodash/find"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _orderBy2 = _interopRequireDefault(require("lodash/orderBy"));
var _isUndefined2 = _interopRequireDefault(require("lodash/isUndefined"));
var _dateFns = require("date-fns");
var _constants = require("../constants");
const dateFormat = 'DD MMM YYYY';

/**
 *
 * @param history
 * @param orders
 * @param formatPrice
 * @returns {Array}
 */
function walletHistoryFactory(history, orders, formatPrice) {
  const redeems = (0, _get2.default)(history, 'data.history.redeems', []);
  const rewards = (0, _get2.default)(history, 'data.history.rewards', []);
  const expiredRewards = (0, _get2.default)(history, 'data.history.expiredRewards', []);
  const transactions = [...getFormattedTransactions(redeems, orders, formatPrice, '-', _constants.WALLET_TRANSACTION_TYPE.REDEEM), ...getFormattedTransactions(rewards, orders, formatPrice, '+', _constants.WALLET_TRANSACTION_TYPE.REWARD), ...getFormattedTransactions(expiredRewards, orders, formatPrice, '-', _constants.WALLET_TRANSACTION_TYPE.EXPIRED)];
  return (0, _orderBy2.default)(transactions, 'timestamp', 'desc');
}

/**
 * format transaction
 * @param transactions
 * @param orders
 * @param formatPrice
 * @param symbol
 * @param transactionType
 * @returns {*}
 */
function getFormattedTransactions(transactions, orders, formatPrice, symbol, transactionType) {
  return transactions.map(transaction => {
    const isPWM = (0, _get2.default)(transaction, 'burnType') === 'PWM';
    const order = isPWM ? orders.find(order => order.additionalData.saleId === transaction.trackId) : (0, _find2.default)(orders, {
      trackId: transaction.trackId
    });
    const status = (0, _get2.default)(transaction, 'status');
    let fullTransaction = {
      timestamp: transaction.createdAt,
      createdAt: (0, _dateFns.format)((0, _dateFns.parse)(transaction.createdAt), dateFormat),
      hasOrder: !(0, _isUndefined2.default)(order),
      amount: `${symbol} ${formatPrice(transaction.points)}`,
      dayDiffFromCurrentDate: (0, _dateFns.differenceInCalendarDays)((0, _dateFns.parse)(transaction.createdAt), new Date()),
      status,
      isReward: transactionType === _constants.WALLET_TRANSACTION_TYPE.REWARD,
      isExpired: transactionType === _constants.WALLET_TRANSACTION_TYPE.EXPIRED,
      isPending: status === _constants.WALLET_HISTORY_STATUS.PENDING,
      isAvailableReward: status === _constants.WALLET_HISTORY_STATUS.AVAILABLE,
      isCancelled: status === _constants.WALLET_HISTORY_STATUS.CANCELLED,
      isRedeemed: status === _constants.WALLET_HISTORY_STATUS.REDEEMED,
      isReversed: (0, _get2.default)(transaction, 'reversed', false),
      isRefund: _constants.WALLET_TRANSACTION_TYPE.REFUND === transaction.earnType,
      earnType: transaction.earnType,
      burnType: transaction.burnType
    };
    if (order) {
      const product = (0, _find2.default)((0, _get2.default)(order, 'products'), {
        type: _constants.PRODUCT_TYPES.FLIGHT
      }) || (0, _find2.default)((0, _get2.default)(order, 'products'), {
        type: _constants.PRODUCT_TYPES.HOTEL
      }) || (0, _find2.default)((0, _get2.default)(order, 'products'), {
        type: _constants.PRODUCT_TYPES.ACCOMMODATION
      }) || (0, _find2.default)((0, _get2.default)(order, 'products'), {
        type: _constants.PRODUCT_TYPES.GIFTCARD
      }) || (0, _find2.default)((0, _get2.default)(order, 'products'), {
        type: 'points-exchange'
      });
      fullTransaction = {
        ...fullTransaction,
        orderId: order.orderId,
        orderNumber: order.orderNumber,
        productType: product.type
      };
    }
    return fullTransaction;
  });
}